import { ReactNode } from 'react';
import { Glyphicon } from 'react-bootstrap';
import useSidePanel from 'components/sidePanel/useSidePanel';
import SidePanel from 'components/sidePanel/SidePanel';
import {
  AutomationsHeaderContainer,
  MenuButtonStyled,
} from './AutomationsHeader.styles';
import { automationsSidePanelId } from './Automations.constants';

const AutomationsHeader = ({
  hamburgerMenuContent,
}: {
  hamburgerMenuContent?: ReactNode;
}) => {
  const { triggerClassName, toggleSidePanel } = useSidePanel({
    sidePanelId: automationsSidePanelId,
  });

  return (
    <AutomationsHeaderContainer>
      {hamburgerMenuContent && (
        <>
          <MenuButtonStyled
            data-testid="automations-hamburger-menu"
            onClick={toggleSidePanel}
            className={triggerClassName}
            bsStyle="default"
          >
            <Glyphicon glyph="menu-hamburger" />
          </MenuButtonStyled>
          <SidePanel sidePanelId={automationsSidePanelId}>
            {hamburgerMenuContent}
          </SidePanel>
        </>
      )}
    </AutomationsHeaderContainer>
  );
};

AutomationsHeader.defaultProps = {
  hamburgerMenuContent: null,
};

export default AutomationsHeader;
